"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const FiltroBox_vue_1 = __importDefault(require("./FiltroBox.vue"));
const FiltroDebug_vue_1 = __importDefault(require("./FiltroDebug.vue"));
const FiltroRadio_vue_1 = __importDefault(require("./FiltroRadio.vue"));
const FiltroPrecios_vue_1 = __importDefault(require("./FiltroPrecios.vue"));
const FiltroCheckbox_vue_1 = __importDefault(require("./FiltroCheckbox.vue"));
const FiltroCiudades_vue_1 = __importDefault(require("./FiltroCiudades.vue"));
const FiltroAmbientes_vue_1 = __importDefault(require("./FiltroAmbientes.vue"));
const FiltrosAplicados_vue_1 = __importDefault(require("./FiltrosAplicados.vue"));
const FiltroAntiguedad_vue_1 = __importDefault(require("./FiltroAntiguedad.vue"));
const FiltroSuperficies_vue_1 = __importDefault(require("./FiltroSuperficies.vue"));
const FiltroRadioPreloader_vue_1 = __importDefault(require("./FiltroRadioPreloader.vue"));
const FiltroCheckboxPreloader_vue_1 = __importDefault(require("./FiltroCheckboxPreloader.vue"));
let FiltrosAside = class FiltrosAside extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.params = this.value;
        this.tipo = this.value.tipo;
        this.barrios = this.value.barrios;
        this.operacion = this.value.operacion;
        this.precio = this.params.precio;
        this.antiguedad = this.params.antiguedad;
        this.superficie = {
            key: "CUB",
            total: this.filtros.superficie_total,
            cubierta: this.filtros.superficie_cubierta,
        };
    }
    onParamsChanged() {
        if (this.precio !== this.params.precio) {
            this.precio = this.params.precio;
        }
        if (this.antiguedad !== this.params.antiguedad) {
            this.antiguedad = this.params.antiguedad;
        }
        if (this.superficie.key === "TOT") {
            if (this.superficie.total !== this.params.superficie_total) {
                this.superficie.total = this.params.superficie_total;
            }
        }
        else if (this.superficie.key === "CUB") {
            if (this.superficie.cubierta !== this.params.superficie_cubierta) {
                this.superficie.cubierta = this.params.superficie_cubierta;
            }
        }
        this.$emit("input", this.params);
    }
    onPrecioChanged() {
        if (this.params.precio !== this.precio) {
            this.params.precio = this.precio;
        }
    }
    onAntiguedadChanged() {
        if (this.params.antiguedad !== this.antiguedad) {
            this.params.antiguedad = this.antiguedad;
        }
    }
    onSuperficieChanged() {
        if (this.superficie.key === "TOT") {
            if (this.params.superficie_total !== this.superficie.total) {
                this.params.superficie_total = this.superficie.total;
            }
            this.params.superficie_cubierta = this.filtros.superficie_cubierta;
        }
        else if (this.superficie.key === "CUB") {
            if (this.params.superficie_cubierta !== this.superficie.cubierta) {
                this.params.superficie_cubierta = this.superficie.cubierta;
            }
            this.params.superficie_total = this.filtros.superficie_total;
        }
    }
    onTipoChanged() {
        this.redirect();
    }
    onBarriosChanged() {
        this.redirect();
    }
    onOperacionChanged() {
        this.redirect();
    }
    redirect() {
        let url = "";
        if (this.tipo) {
            let filtro = lodash_1.default.find(this.filtros.tipos, ["id", this.tipo]);
            url += filtro.slug;
        }
        if (this.operacion) {
            let filtro = lodash_1.default.find(this.filtros.operaciones, [
                "id",
                this.operacion,
            ]);
            if (this.tipo) {
                url += `-para-`;
            }
            url += filtro.slug;
        }
        if (this.barrios.length) {
            let filtros = [];
            this.barrios.forEach((value) => {
                this.filtros.ciudades.forEach((ciudad) => {
                    let barrio = lodash_1.default.find(ciudad.barrios, ["id", value]);
                    if (barrio) {
                        filtros.push(barrio);
                    }
                });
            });
            console.log(filtros);
            if (filtros.length === 1) {
                url += `-en-${filtros[0].slug}`;
            }
            else {
                let query = [];
                filtros.forEach((filtro) => {
                    query.push(`barrios[]=${filtro.id}`);
                });
                url += `?` + query.join("&");
            }
        }
        window.location.href = url;
        return true;
    }
    isFiltro(key) {
        return (this.filtros && lodash_1.default.hasIn(this.filtros, key) && this.filtros[key].length);
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], FiltrosAside.prototype, "value", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], FiltrosAside.prototype, "filtros", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: true }),
    __metadata("design:type", Boolean)
], FiltrosAside.prototype, "visible", void 0);
__decorate([
    vue_property_decorator_1.Watch("params", { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FiltrosAside.prototype, "onParamsChanged", null);
__decorate([
    vue_property_decorator_1.Watch("precio"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FiltrosAside.prototype, "onPrecioChanged", null);
__decorate([
    vue_property_decorator_1.Watch("antiguedad"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FiltrosAside.prototype, "onAntiguedadChanged", null);
__decorate([
    vue_property_decorator_1.Watch("superficie", { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FiltrosAside.prototype, "onSuperficieChanged", null);
__decorate([
    vue_property_decorator_1.Watch("tipo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FiltrosAside.prototype, "onTipoChanged", null);
__decorate([
    vue_property_decorator_1.Watch("barrios"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FiltrosAside.prototype, "onBarriosChanged", null);
__decorate([
    vue_property_decorator_1.Watch("operacion"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FiltrosAside.prototype, "onOperacionChanged", null);
FiltrosAside = __decorate([
    vue_property_decorator_1.Component({
        components: {
            FiltroBox: FiltroBox_vue_1.default,
            FiltroDebug: FiltroDebug_vue_1.default,
            FiltroRadio: FiltroRadio_vue_1.default,
            FiltroPrecios: FiltroPrecios_vue_1.default,
            FiltroCheckbox: FiltroCheckbox_vue_1.default,
            FiltroCiudades: FiltroCiudades_vue_1.default,
            FiltroAmbientes: FiltroAmbientes_vue_1.default,
            FiltrosAplicados: FiltrosAplicados_vue_1.default,
            FiltroAntiguedad: FiltroAntiguedad_vue_1.default,
            FiltroSuperficies: FiltroSuperficies_vue_1.default,
            FiltroRadioPreloader: FiltroRadioPreloader_vue_1.default,
            FiltroCheckboxPreloader: FiltroCheckboxPreloader_vue_1.default,
        },
    })
], FiltrosAside);
exports.default = FiltrosAside;
